import React, { useState, useEffect, useContext, JSX } from 'react';

import { cmnContext } from '../../../../../../../../../common/CmnContext';


// シチュエーション各行で表示するラベル：ミッション・台本
function PracticeReserveSituationLineLabel(props: any) {

  const info = props.info;
  const isDisabled = props.isDisabled;
  const isPc = useContext(cmnContext).isPc;

  // ツールチップ表示
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);


  // ミッション：フォーカスin:PCのみツールチップ表示
  const onMouseEnter = () => {
    if(isPc) {
      setIsTooltipVisible(true);
    }
  }
  // ミッション：フォーカスout:PCのみツールチップ非表示
  const onMouseLeave = () => {
    if(isPc) {
      setIsTooltipVisible(false);
    }
  }
  // タップ:ツールチップ表示
  const onTouchStart = () => {
    setIsTooltipVisible(true);
  }

  // スクロール検知:ツールチップ非表示
  useEffect(() => {
    const handleScroll = () => {
      setIsTooltipVisible(false);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  const toolStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: '105%',
    left: '0',
    width: 'auto',
    minWidth: isPc? '30vw' : '80vw',
    maxWidth: isPc? '50vw' : '90vw',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    color: 'white',
    padding: '10px',
    borderRadius: '5px',
    fontSize: '14px',
    zIndex: 1,
  };


  return (
    <>
    {(info && !isDisabled) &&
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <>
        {info.mission_ja && (
          <span
            className="btn btn-primary btn_customize balloon_js"
            style={{fontSize: '80%', padding: '3px 10px', margin: '0 3px 10px 0',}}
            title={info.mission_ja}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onTouchStart={onTouchStart}
          >
            <i className="fas fa-info-circle"></i> ミッション
          </span>
        )}
        {info.upfile && (
          <a
            href={`/images/upload/practice/${info.upfile}`}
            className="btn btn-primary btn_customize"
            style={{fontSize: '90%', padding: '3px 10px', margin: '0 3px 10px 0',}}
          >
            <i className="fa fa-book"></i> 台本
          </a>
        )}

        {/* ツールチップ */}
        {isTooltipVisible && info.mission_ja && (
          <div style={toolStyle}>
            {info.mission_ja.trim().split('\n').map((line: string, index: number) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </div>
        )}
        </>
      </div>
    }
    </>
  );
}
  
export default PracticeReserveSituationLineLabel;